import { convertHtmlToPlainText } from '../convert-html-to-plain-text/convert-html-to-plain-text.function';

export function copyHtmlToClipboard(html: string): void {
  const listener = (event): void => {
    event.clipboardData.setData('text/html', html);
    event.clipboardData.setData('text/plain', convertHtmlToPlainText(html));
    event.preventDefault();
  };

  document.addEventListener('copy', listener);
  document.execCommand('copy');
  document.removeEventListener('copy', listener);
}
